import React, { useState } from "react";
import TextInput from "../components/TextInput";
import Button from "../components/Button";
import FileUpload from "../components/FileUpload";
import { useNavigate } from "react-router-dom";
import { usePostFormData } from "../hooks";
import { fireGenericErrorModal, firePostSuccessModal } from "../utils/swals";
import { SignIn } from "../utils/auth";
import { usePartido } from "../context/PartidoContext";
import { checkPhoneValid } from "../utils/validation";
const FormularioFotografo = () => {
  const [form, setForm] = useState({
    nombre: "",
    apellido: "",
    DNI: "",
    nARGRA: "",
    medio: "",
    file: null,
    email: "",
    celular: ""
  });
  const { postFormData, isLoading, error } = usePostFormData(false);
  const navigate = useNavigate();
  const { selectedPartido, setSelectedPartido } = usePartido();

  const isComplete =
    Object.values(form).every(Boolean) && checkPhoneValid(form.celular);

  const handleSubmit = async () => {
    const formData = new FormData();
    formData.append("nombre", form.nombre + " " + form.apellido);
    formData.append("dni", form.DNI);
    formData.append("nARGRA", form.nARGRA);
    formData.append("medio", form.medio);
    formData.append("carnetARGRA", form.file);
    formData.append("email", form.email);
    formData.append("celular", form.celular);

    const result = await postFormData("/registrar-fotografo", formData);

    if (result.status === "KO") {
      fireGenericErrorModal();
    } else {
      // El segundo parametro = true es para senalizar que no es verificado.
      SignIn(result.token, { isF: true });
      if (selectedPartido) {
        navigate(`/acreditacion-fotografo/${selectedPartido.id}`);
      } else {
        navigate("/");
      }
    }
  };

  return (
    <div className="bg-gray">
      <div className="nv-wrapper">
        <div className="nv-box">
          <h1>Completá el siguiente formulario</h1>
          <div className="nv-form">
            <div className="input-flex">
              <TextInput
                placeholder={"Nombre"}
                onChange={(e) =>
                  setForm((prevState) => ({
                    ...prevState,
                    nombre: e.target.value,
                  }))
                }
                value={form.nombre}
              />
              <TextInput
                placeholder={"Apellido"}
                onChange={(e) =>
                  setForm((prevState) => ({
                    ...prevState,
                    apellido: e.target.value,
                  }))
                }
                value={form.apellido}
              />
            </div>
              <div className="input-flex">
                  <TextInput
                      placeholder={"Email"}
                      onChange={(e) =>
                          setForm((prevState) => ({
                              ...prevState,
                              email: e.target.value,
                          }))
                      }
                      value={form.email}
                  />
                  <TextInput
                      placeholder={"Celular"}
                      onChange={(e) =>
                          setForm((prevState) => ({
                              ...prevState,
                              celular: e.target.value,
                          }))
                      }
                      value={form.celular}
                  />
              </div>
              <div className="input-flex">
                  <TextInput
                      placeholder={"DNI"}
                      onChange={(e) =>
                          setForm((prevState) => ({
                              ...prevState,
                              DNI: e.target.value,
                          }))
                      }
                      noDots={true}
                      value={form.DNI}
                  />
                  <TextInput
                      placeholder={"N° de ARGRA"}
                      onChange={(e) =>
                          setForm((prevState) => ({
                              ...prevState,
                              nARGRA: e.target.value,
                          }))
                      }
                      value={form.nARGRA}
                  />
              </div>


            <div>
              <h6>Adjuntá tu carnet de ARGRA</h6>
              <FileUpload
                file={form.file}
                setFile={(newFile) =>
                  setForm((prevState) => ({ ...prevState, file: newFile }))
                }
              />
            </div>
            <TextInput
              placeholder={"Medio al que pertenecés"}
              onChange={(e) =>
                setForm((prevState) => ({
                  ...prevState,
                  medio: e.target.value,
                }))
              }
              value={form.medio}
            />
            <Button
              variant={`login-btn ${isComplete && !isLoading ? "enabled" : ""}`}
              isDisabled={!isComplete || isLoading}
              style={{ alignSelf: "none" }}
              onClick={handleSubmit}
            >
              Enviar
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FormularioFotografo;
